import { ButtonCTA, ButtonText } from '@davies-group/white-label-ui/ui';
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface IConfirmDialogProps {
    title: string;
    children: JSX.Element;
    open: boolean;
    setOpen: (open: boolean) => void;
    onConfirm: () => void;
}

const ConfirmDialog = (props: IConfirmDialogProps) => {
    const { title, children, open, setOpen, onConfirm } = props;
    return (
        <Dialog data-testid="confirm-dialog" open={open} onClose={() => setOpen(false)} aria-labelledby="confirm-dialog">
            <DialogTitle data-testid="confirm-dialog-title" id="confirm-dialog">
                {title}
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <ButtonText onClick={() => setOpen(false)}>Upload more</ButtonText>
                <ButtonCTA
                    data-testid="confirm-dialog-button-confirm"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                >
                    Send
                </ButtonCTA>
            </DialogActions>
        </Dialog>
    );
};
export default ConfirmDialog;
